import React from 'react';
import PropTypes, { any } from 'prop-types';
import Filter, { FilterModal, FilterSection } from './Filter';
import DropdownFilter from './FilterComponents/CoreComponents/DropdownFilter';

import styles from '../search.scss';

const CollegesFilter = (props) => {
    const { filters, filterInputs, handleFilterClick, filterModal, closeModals, handleFilterSubmit, isPowerUser, handleOnUpgradeToPowerClick, searchTypes, handleFilterUpdate, mobileOnly, desktopOnly, 'data-testid': dataTestId } = props;

    const divisions = searchTypes && searchTypes.divisions ? searchTypes.divisions : [];
    const conferences = searchTypes && searchTypes.conferences ? searchTypes.conferences : [];
    const colleges = searchTypes && searchTypes.colleges ? searchTypes.colleges : [];
    const filterName = 'colleges';

    return (
        <div className={styles.filterWrapper}>
            <Filter
                filterName={filterName}
                isActive={(filters && (filters.college || filters.division || filters.conference)) || filterModal === filterName}
                onClick={() => {
                    if (isPowerUser) {
                        handleFilterClick(filterName);
                    } else {
                        handleOnUpgradeToPowerClick(filterName);
                    }
                }}
                handleFilterClick={handleFilterClick}
                mobileOnly={mobileOnly}
                desktopOnly={desktopOnly}
                data-testid={dataTestId}
            >
                Colleges
            </Filter>
            {filterModal === filterName && (
                <FilterModal
                    title={'Colleges'}
                    handleFilterSubmit={handleFilterSubmit}
                    onCloseClick={closeModals}
                    data-testid={dataTestId}
                >
                    <FilterSection>
                        <DropdownFilter
                            options={divisions}
                            selected={filterInputs.division}
                            placeholder={'Any Division'}
                            onChange={(division) => {
                                handleFilterUpdate({ division });
                            }}
                            data-testid={dataTestId && `${dataTestId}.division-dropdown`}
                        />
                    </FilterSection>
                    <FilterSection>
                        <DropdownFilter
                            options={conferences}
                            selected={filterInputs.conference}
                            placeholder={'Any Conference'}
                            onChange={(conference) => {
                                handleFilterUpdate({ conference });
                            }}
                            data-testid={dataTestId && `${dataTestId}.conference-dropdown`}
                        />
                    </FilterSection>
                    <FilterSection>
                        <DropdownFilter
                            options={colleges}
                            selected={filterInputs.college}
                            placeholder={'Any College'}
                            onChange={(college) => {
                                handleFilterUpdate({ college });
                            }}
                            data-testid={dataTestId && `${dataTestId}.college-dropdown`}
                        />
                    </FilterSection>
                </FilterModal>
            )}
        </div>
    );
};

CollegesFilter.propTypes = {
    filters: PropTypes.objectOf(any),
    filterInputs: PropTypes.objectOf(any),
    handleFilterClick: PropTypes.func,
    filterModal: PropTypes.string,
    closeModals: PropTypes.func,
    handleFilterSubmit: PropTypes.func,
    isPowerUser: PropTypes.bool,
    handleOnUpgradeToPowerClick: PropTypes.func.isRequired,
    searchTypes: PropTypes.objectOf(any),
    handleFilterUpdate: PropTypes.func,
    mobileOnly: PropTypes.bool,
    desktopOnly: PropTypes.bool,
    'data-testid': PropTypes.string,
};

CollegesFilter.defaultProps = {
    filters: {},
    filterInputs: {},
    handleFilterClick: () => { },
    filterModal: '',
    closeModals: () => { },
    handleFilterSubmit: () => { },
    isPowerUser: false,
    searchTypes: {},
    handleFilterUpdate: () => { },
    mobileOnly: false,
    desktopOnly: false,
    'data-testid': undefined,
};
export default CollegesFilter;
